export const Env = {
  production: false,
  apiUrl: 'https://page-dev-api.beam.live/',
  gpsUrl: 'https://page-dev-gps.beam.live/',
  apiVersion: 'v2',
  sharedUrl: 'https://shared-live.staging.beam.live'
};
